import React, { memo } from 'react'

import styles from './style.module.css'

export type SpNumericKeypadProps = {
  onClickNumber: (value: string) => void
  onClickBackSpace: () => void
  onClickEnter: () => void
  disabledEnter?: boolean
}

const NUMBERS = ['1', '2', '3', '4', '5', '6', '7', '8', '9']

// SP 用テンキー。1-9 を 3 列で並べ、右列に「一文字消す」「決定」を配置する。
// 総合受付の電話番号入力・パスコード入力で共用（見た目・挙動を統一）。
const SpNumericKeypad = ({
  onClickNumber,
  onClickBackSpace,
  onClickEnter,
  disabledEnter = false,
}: SpNumericKeypadProps) => (
  <div className={styles.numberGrid}>
    {NUMBERS.map((num, i) => (
      <button
        key={num}
        type="button"
        className={styles.button}
        onClick={() => onClickNumber(num)}
        style={{ gridRow: Math.floor(i / 3) + 1, gridColumn: (i % 3) + 1 }}
      >
        {num}
      </button>
    ))}
    <button
      type="button"
      className={styles.button}
      onClick={() => onClickNumber('0')}
      style={{ gridRow: 4, gridColumn: 2 }}
    >
      0
    </button>
    <button
      type="button"
      className={`${styles.button} ${styles.backspaceButton}`}
      onClick={onClickBackSpace}
    >
      一文字
      <br />
      消す
    </button>
    <button
      type="button"
      className={`${styles.button} ${styles.enterButton} ${disabledEnter ? styles.enterButtonDisabled : ''}`}
      disabled={disabledEnter}
      onClick={onClickEnter}
    >
      決定
    </button>
  </div>
)

export default memo(SpNumericKeypad)
